// @flow
import React, {useEffect} from 'react';
import { connect } from 'react-redux';
import type { Connector } from 'react-redux';
// Components
import ProductSquare from '../../products/components/ProductSquare';
// Selectors
import { productsByIdsSelector, loadingByIdsSelector } from '../../products/selectors';
// Actions
import { findMultipleProducts } from '../../products/actions';
// Types
import type { Product } from '../../types';

type OwnProps = {
  productIds: number[],
  title: string,
};

type Props = OwnProps & {
  isLoading: boolean,
  products: Product[],
  findMultipleProducts: (number[]) => void,
};

const SubDepartmentProductsCards = (props: Props) => {
  useEffect(() => {
    props.findMultipleProducts(props.productIds);
  },[])

  return <>{props.products.map((product) => (
            <div key={product.id}>
              <ProductSquare
                productImage={product.images[0]}
                productName={product.name}
                productManufacturer={product.manufacturer}
                productListPrice={product.listPrice}
                productPrice={product.price}
                productUnit={product.unitForQuantity}
                productSlug={product.slug}
                productId={product.id}
                parentProductId={product.productId}
                productTotalOnHand={product.totalOnHand}
                defaultQuantity={product.defaultQuantity}
                incrementQuantity={product.incrementQuantity}
                inStock={product.inStock}
                discontinued={product.discontinued}
                analyticsViewSource={props.title} // USE ANALYTICS
              />
            </div>
  ))}</>;
}

const mapStateToProps = (state: mixed, ownProps: OwnProps) => {
  return {
    products: productsByIdsSelector(state, ownProps.productIds),
    isLoading: loadingByIdsSelector(state, ownProps.productIds),
  };
};

const mapDispatchToProps = (dispatch: Dispatch, ownProps: OwnProps) => {
  return {
    findMultipleProducts: (ids: number[]) => {
      dispatch(findMultipleProducts(ids));
    },
  };
};

const connector: Connector<OwnProps, Props> = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default connector(SubDepartmentProductsCards);
